module.exports = __webpack_public_path__ + "Flama-Medium.woff?174a8a14ce48e756e9478838a81722a5";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Medium.woff
// module id = 915
// module chunks = 0